// hostdime => export const url_base = 'http://api.tassi.syseu.com/ApiTassi/';
export const url_base = 'https://desarrollo.api.mia.tassi.syseu.com.co/';
export const url_socket = 'https://desarrollo.socket.mia.tassi.syseu.com.co';


